// [feat] 2024.08.11 Greta -  Quote App | Main function

// DOM 元素
// const addQuoteBtns = document.querySelectorAll(".addQuoteListBtn");
const quoteListContainer = document.getElementById("quote-list");
const quoteListCheckContainer = document.getElementById("quote-list-check");
const quoteController = document.getElementById("quote-popup-form-control");
const quoteCloseBtn = document.getElementById("quote-popup-form-close-btn");
const quoteHeader = document.getElementById("quote-popup-form-header");
const quoteFooter = document.getElementById("quote-popup-form-footer");
const nextStepButton = document.getElementById("nextStepButton");
const prevStepButton = document.getElementById("prevStepButton");
const continueShopping = document.getElementById("continueShopping");
const continueShoppingCopy = document.getElementById("continueShoppingCopy");
const submitButton = document.getElementById("submitButton");
const steps = document.querySelectorAll(".grfq__popupForm__step");
const formContent = document.querySelector(
  "#quote-popup-modal .grfq__popupForm__content"
);
const form = document.querySelector("#quote-form");
const formCheck = document.querySelector("#quote-form-check");
const counterEl = document.getElementById("quote-count");
const addQuoteNotification = document.getElementById(
  "add-quote-notification"
);

// 狀態變數
let currentStep = 1;
let quoteList = JSON.parse(localStorage.getItem("quoteList")) || [];
let quoteCounter = JSON.parse(localStorage.getItem("quoteList"))?.length || 0;
let isSubmitting = false;

// 初始化
captureUTMParams();
updateButtons();
loadQuoteList();
setCounter(quoteCounter);

// 事件監聽器
nextStepButton.addEventListener("click", handleNextStep);
prevStepButton.addEventListener("click", handlePrevStep);
continueShopping.addEventListener("click", closePanelForm);
continueShoppingCopy.addEventListener("click", closePanelForm);
quoteController.addEventListener("change", handleQuoteControllerChange);
["text-name", "email"].forEach((fieldName) => {
  form.elements[fieldName].addEventListener("input", () =>
    validateField(fieldName)
  );
});
form.addEventListener("submit", handleQuoteFormSubmission);

// 函數定義
// [fix] 2024.09.19 Greta -  refactor and optimize
function addQuoteItem(getItemDataFn, e) {
  const newItem = getItemDataFn(e.target);
  const existingItem = getExistingItem(newItem.id, newItem.variantId);
  const addQty = parseInt(document.querySelector("#quantity")?.value || "1");

  if (existingItem) {
    existingItem.qty = (parseInt(existingItem.qty) || 0) + addQty;
  } else {
    quoteList.push(newItem);
  }

  updateQuoteState();
}

// 從產品頁面添加報價項目
function addQuoteItemFromProductPage(e) {
  addQuoteItem(getNewItemData, e);
}

// 從產品列表添加報價項目
function addQuoteItemFromProductBlock(e) {
  addQuoteItem(getNewItemDataFromProductBlock, e);
}

// 取得新項目資料（從產品頁面）
function getNewItemData(target) {
    // [fix]2025.01.10 Greta - Fix Google translate addQuoteListBtn Error
  if (target.tagName === 'FONT') {
      // if google translate font tag appears
      target = target.closest('.addQuoteListBtn');
  }
  const selectedVariant = getSelectedVariant();
  const dataId = target.dataset.id;
  const dataTitle = target.dataset.title;
  const dataUrl = `${target.dataset.url}${
    selectedVariant.id ? `?variant=${selectedVariant.id}` : ""
  }`;
  const dataSku = selectedVariant.sku;
  const dataImgUrl = selectedVariant.featured_image
    ? selectedVariant.featured_image.replace(/\.jpg(?=\?|$)/, "_small.jpg")
    : target.dataset.img;
  const dataQty = document.querySelector("#quantity")?.value || "1";
  const dataVariantTitle = selectedVariant.title === "Default Title" ? target.dataset.vtitle : selectedVariant.title;
  const dataVariantId = selectedVariant.id;

  return {
    id: dataId,
    title: dataTitle,
    variantTitle: dataVariantTitle,
    variantId: dataVariantId,
    url: dataUrl,
    sku: dataSku,
    img: `https:${dataImgUrl}`,
    qty: dataQty,
  };
}

// 取得新項目資料（從產品列表）
function getNewItemDataFromProductBlock(target) {
  // [fix]2025.01.10 Greta - Fix Google translate addQuoteListBtn Error
  if (target.tagName === 'FONT') {
      // if google translate font tag appears
      target = target.closest('.addQuoteListBtn');
  }
  const { id, title, vid: variantId, vtitle: variantTitle, url, sku, img } = target.dataset;
  const dataUrl = `${url}${variantId ? `?variant=${variantId}` : ""}`;
  const dataQty = document.querySelector("#quantity")?.value || "1";

  return {
    id,
    title,
    variantTitle: variantTitle === "Default Title" ? "" : variantTitle,
    variantId,
    url: dataUrl,
    sku,
    img: `https:${img}`,
    qty: dataQty,
  };
}

// 更新報價狀態
function updateQuoteState() {
  localStorage.setItem("quoteList", JSON.stringify(quoteList));
  setCounter(quoteList.length);
  loadQuoteList();
  updateButtons();
  setAddQuoteNotification();
}

function getSelectedVariant() {
  const url = new URL(window.location.href);
  let variantId = url.searchParams.get("variant");

  if (variantId) {
    variantId = parseInt(variantId, 10);

    var matchedVariant = productData.productVariants.find(function (variant) {
      return variant.id == variantId;
    });

    if (matchedVariant) {
      // console.log("matched variant:", matchedVariant);
      return matchedVariant;
    } else {
      // console.log("no matched variant");
      return productData.productVariants[0];
    }
  } else {
    // console.log("no variant param in url");
    return productData.productVariants[0];
  }
}

function getExistingItem(id, variantId) {
  // console.log(variantId);
  return quoteList.find(
    (item) => item.id === id && item.variantId === variantId
  );
}

function setAddQuoteNotification() {
  addQuoteNotification.style.visibility = "visible";
  addQuoteNotification.style.marginTop = "48px";
  addQuoteNotification.style.opacity = "1";
  setTimeout(() => {
    addQuoteNotification.style.marginTop = "0px";
    addQuoteNotification.style.opacity = "0";
    addQuoteNotification.style.visibility = "hidden";
  }, 1500);
}

function loadQuoteList() {
  quoteListContainer.innerHTML = "";
  quoteListCheckContainer.innerHTML = "";
  quoteList.forEach((item, index) => {
    const row = createQuoteListRow(item, index);
    const rowCopy = createQuoteListCheckRow(item, index);
    quoteListContainer.appendChild(row);
    quoteListCheckContainer.appendChild(rowCopy);
  });
  form.elements["quoteListHidenField"].value = JSON.stringify(quoteList);
  setupQuantityListeners();
  addRemoveItemListeners();
}

function createQuoteListRow(item, index) {
  const row = document.createElement("tr");
  row.innerHTML = `
    <td data-label="產品資訊" class="grfq__popupForm__tdMedia">
      <div class="grfq__popupForm__itemThumb">
        <img
          class="grfq__popupForm__itemThumbImg"
          src="${item.img}"
          alt="${item.title}"
          width="72"
          height="72"
        >
      </div>
    </td>
    <td data-label="產品資訊" class="grfq__popupForm__tdVariant grfq__popupForm__tdVariantSmaller">
      <div class="grfq__popupForm__itemThumb">
        <img
          class="grfq__popupForm__itemThumbImg"
          src="${item.img}"
          alt="${item.title}"
          width="48"
          height="48"
        >
      </div>
      <div class="grfq__popupForm__itemTitle">
        <a href="${item.url}" target="_blank">${item.title}</a>
        ${
          item.variantTitle
            ? `<p class="grfq__popupForm__itemOptions">${item.variantTitle}</p>`
            : ""
        }
        ${
          item.sku
            ? `<p class="grfq__popupForm__itemSKU">${item.sku}</p>`
            : ""
        }
      </div>
    </td>
    <td data-label="數量" class="grfq__popupForm__tdQuantity">
      <div class="grfq__popupForm__tdQuantityGroup">
        <input
          type="number"
          value="${item.qty}"
          data-item-qty="${item.qty}"
          data-item-index="${index}"
          min="0"
          class="quote-item-qty"
        >
        <button
          class="grfq__popupForm__itemActionDelete"
          data-item-index="${index}"
        >
          <svg class="grfq__popupForm__itemActionDeleteIcon" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
        </button>
      </div>
    </td>
  `;
  return row;
}

function createQuoteListCheckRow(item, index) {
  const row = document.createElement("tr");
  row.innerHTML = `
  <td data-label="產品資訊" class="grfq__popupForm__tdMedia">
    <div class="grfq__popupForm__itemThumb">
      <img
        class="grfq__popupForm__itemThumbImg"
        src="${item.img}"
        alt="${item.title}"
        width="72"
        height="72"
      >
    </div>
  </td>
  <td data-label="產品資訊" class="grfq__popupForm__tdVariant grfq__popupForm__tdVariantSmaller">
    <div class="grfq__popupForm__itemThumb">
      <img
        class="grfq__popupForm__itemThumbImg"
        src="${item.img}"
        alt="${item.title}"
        width="48"
        height="48"
      >
    </div>
    <div class="grfq__popupForm__itemTitle">
      <a href="${item.url}" target="_blank">${item.title}</a>
      ${
        item.variantTitle
          ? `<p class="grfq__popupForm__itemOptions">${item.variantTitle}</p>`
          : ""
      }
      ${item.sku ? `<p class="grfq__popupForm__itemSKU">${item.sku}</p>` : ""}
    </div>
  </td>
  <td data-label="數量" class="grfq__popupForm__tdQuantity">
      ${item.qty}
  </td>
`;
  return row;
}

function setCounter(num) {
  quoteCounter = num;
  counterEl.textContent = num;
  return;
}

function updateQuoteItemQuantity(itemIndex, newQty) {
  // const itemIndex = quoteList.findIndex(item => item.id === itemId && item.variantId === variantId);
  let quoteList = JSON.parse(localStorage.getItem("quoteList")) || [];
  // console.log(itemIndex);
  if (itemIndex !== -1) {
    quoteList[itemIndex].qty = newQty;
    localStorage.setItem("quoteList", JSON.stringify(quoteList));
  }
}

function setupQuantityListeners() {
  document.querySelectorAll(".quote-item-qty").forEach((input) => {
    input.addEventListener("change", function () {
      // console.log("changing");
      const itemId = this.dataset.id;
      const itemIndex = this.dataset.itemIndex;
      // console.log(itemIndex);
      const newQty = parseInt(this.value);
      updateQuoteItemQuantity(itemIndex, newQty);
    });
  });
}

function addRemoveItemListeners() {
  const removeItemBtns = quoteListContainer.querySelectorAll(
    ".grfq__popupForm__itemActionDelete"
  );
  removeItemBtns.forEach((btn) => {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      // console.log("click");
      removeItem(btn.dataset.itemIndex);
    });
  });
}

function removeItem(index) {
  quoteList.splice(index, 1);
  localStorage.setItem("quoteList", JSON.stringify(quoteList));
  setCounter(quoteList.length);
  loadQuoteList();
  updateButtons();
}

function updateButtons() {
  continueShopping.style.display = currentStep == 1 ? "inline-block" : "none";
  prevStepButton.style.display = currentStep > 1 ? "inline-block" : "none";
  nextStepButton.style.display = currentStep < 3 ? "inline-block" : "none";
  nextStepButton.disabled = quoteCounter == 0 ? true : false;
  submitButton.style.display = currentStep == 3  ? "inline-block" : "none";

  updateStepVisibility();
}

function updateStepVisibility() {
  // console.log("currentStep: " + currentStep);
  // console.log("quoteCounter: " + quoteCounter);
  formContent.querySelector('.grfq__popupForm__contentEmpty[data-step="1"]').style.display =
    currentStep == 1 && quoteCounter == 0 ? "flex" : "none";
  formContent.querySelector('.grfq__popupForm__card[data-step="1"]').style.display =
    currentStep == 1 && quoteCounter > 0 ? "block" : "none";
  formContent.querySelector('[data-step="2"]').style.display =
    currentStep == 2 ? "block" : "none";
  formContent.querySelectorAll('[data-step="3"]').forEach((step3) => {
    step3.style.display = currentStep == 3 ? "block" : "none";
  });
  formContent.querySelector('[data-step="4"]').style.display = currentStep == 4 ? "flex" : "none";
  quoteHeader.style.display = currentStep == 4 ? "none" : "flex";
  quoteCloseBtn.style.position = currentStep == 4 ? "absolute" : "sticky";
  quoteFooter.style.display = currentStep == 4 ? "none" : "block";
}

function printForm() {
  const fields = [
    "text-name",
    "email",
    "text-line",
    "select-channel",
    "body",
  ];

  fields.forEach((field) => {
    const formValue = form.elements[`${field}`].value;
    formCheck.querySelector(`#check-${field}`).innerText = formValue;
  });
}

function handleNextStep(e) {
  e.preventDefault();
  if (currentStep === 2 && !validateForm(e)) {
      return;
  }
  if (currentStep >= 1 && currentStep <= 3 ) {
    steps[currentStep - 1].removeAttribute("data-active");
    steps[currentStep].setAttribute("data-active", "true");
    currentStep++;
  }
  if (currentStep == 3) {
      printForm();
  }
  updateButtons();
}

function handlePrevStep(e) {
  e.preventDefault();
  if (currentStep >= 1 && currentStep <= 3 ) {
    steps[currentStep - 1 ].removeAttribute("data-active");
    currentStep--;
    steps[currentStep - 1].setAttribute("data-active", "true");
    updateButtons();
  }
}

function closePanelForm(e) {
  e.preventDefault();
  quoteController.checked = false;
  currentStep = 1;
  updateStepVisibility();
}

function handleQuoteControllerChange() {
  // if (! quoteController.checked) {
    steps[currentStep - 1].setAttribute("data-active", "false");
    currentStep = 1;
    steps[currentStep - 1].setAttribute("data-active", "true");
    loadQuoteList();
    updateButtons()
  // }
}

function validateForm(e) {
  e.preventDefault();
  return ["text-name", "email"].every(validateField);
}

function validateField(fieldName) {
  const field = form.elements[fieldName];
  const errorElement = field
    .closest(".grfq__popupForm__formGroup")
    .querySelector(".grfq__popupForm__formErrorMessage");
  let isValid = true;

  if (field.value.trim() === "") {
    showError(errorElement);
    isValid = false;
  } else if (fieldName === "email" && !isValidEmail(field.value)) {
    showError(errorElement);
    isValid = false;
  } else {
    hideError(errorElement);
  }

  return isValid;
}

function showError(element) {
  // element.textContent = message;
  element.classList.remove("hidden");
}

function hideError(element) {
  element.classList.add("hidden");
}

function isValidEmail(email) {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
}

function handleQuoteFormSubmission(e) {
e.preventDefault(); // 阻止表單的默認提交行為

if (isSubmitting) return;

const form = document.querySelector("#quote-form");
const userName = form.elements["text-name"].value;
const userEmail = form.elements["email"].value;
const userLineID = form.elements["text-line"].value;
const userChannel = form.elements["select-channel"].value;
const userMessage = form.elements["body"].value;
const quoteList = form.elements["quoteListHidenField"].value;
const isEnglish = form.elements["langHidenField"].value;
const utmParams = getUTMParams();

// 組合要傳送的資料
const data = {
  userName,
  userEmail,
  userLineID,
  userChannel,
  userMessage,
  quoteList,
  isEnglish,
  ...utmParams,
};
// console.log(data);
handleGoogleFormSubmit(data);
}

function stringify(query) {
return Object.keys(query)
  .map(
    (key) => encodeURIComponent(key) + "=" + encodeURIComponent(query[key])
  )
  .join("&");
}

function uploadToGoogleSheet(formId, query) {
return new Promise((resolve, reject) => {
  fetch(
    `https://docs.google.com/forms/d/e/${formId}/formResponse?&${stringify(
      query
    )}&submit=SUBMIT`,
    {
      method: "POST",
      mode: "no-cors", // Google 只會在 'no-cors' 模式下提交表單
      redirect: "follow",
      referrer: "no-referrer",
    }
  )
    .then(() => resolve())
    .catch(() => reject());
});
}

// 當提交表單時呼叫
function handleGoogleFormSubmit(data) {
// 測試區
// const FORM_ID = "1FAIpQLSe4lPQoA1JbCN9SaDwoC82HFAcD_Sl1wY2zYyA8HIATY-KKKw";
//   const query = {
//   "entry.1541692359": data.userName, // 傳送使用者在表單填寫的資訊
//   "entry.149160861": data.userEmail,
//   "entry.2008911978": data.userLineID,
//   "entry.983443951": data.userChannel,
//   "entry.1664047913": data.userMessage,
//   "entry.1942406410": data.quoteList,
//   "entry.1153727597": data.isEnglish,
// };
// 正式區
const FORM_ID = "1FAIpQLSe_iyzEgeQY7U7JhDYs8mA3k0XPJxTbs3uih4T0VdJQ2WlM3w";
const query = {
  "entry.1364292798": data.userName, // 傳送使用者在表單填寫的資訊
  "entry.1395206585": data.userEmail,
  "entry.669438862": data.userLineID,
  "entry.554533824": data.userChannel,
  "entry.2037844469": data.userMessage,
  "entry.1328113675": data.quoteList,
  "entry.666702901": data.isEnglish,
  "entry.1753858939": data.utm_source,   // utm_source（有 UTM 連結才有值，e.g. linktree、LINE、ig）
  "entry.191034763": data.utm_medium,   // utm_medium（e.g. ig、fb、cardbased、social）
  "entry.516018592": data.utm_referrer, // 無 UTM 時的來源 domain（e.g. www.google.com、(direct)）
  "entry.1809819594": data.quote_ref,    // 現場活動來源（QR code 掃描，e.g. 廠商說明會、展覽2025）
};

isSubmitting = true;
submitButton.disabled = true;

uploadToGoogleSheet(FORM_ID, query)
  .then(() => {
    // alert("Form submitted successfully!");
    steps[currentStep - 1].removeAttribute("data-active");
    currentStep = 4;
    updateButtons();
    quoteCounter = 0
    setCounter(quoteCounter);
    quoteList = [];
    localStorage.setItem("quoteList", JSON.stringify(quoteList));
    loadQuoteList();
    return;
  })
  .catch(() => {
    alert("Failed to submit form. Please try again.");
  })
  .finally(() => {
    isSubmitting = false;
    submitButton.disabled = false;
  });
}

// UTM 參數擷取
// - 網址有明確 UTM 參數 → 以新值覆蓋（與 GA4 行為一致）
// - 無 UTM 且 session 未記錄 → 從 referrer 推算（first-touch）
// - 無 UTM 且已記錄 → 保持不變
// - quote_ref 永遠即時更新
function captureUTMParams() {
  const params = new URLSearchParams(window.location.search);

  // quote_ref 永遠更新：使用者主動掃碼，不受 session 保護限制
  if (params.get("quote_ref")) {
    sessionStorage.setItem("quote_ref", params.get("quote_ref"));
  }

  const hasUTM = params.get("utm_source") || params.get("utm_medium");

  if (hasUTM) {
    // 網址有明確 UTM 參數 → 以新值覆蓋
    sessionStorage.setItem("utm_source", params.get("utm_source") || "");
    sessionStorage.setItem("utm_medium", params.get("utm_medium") || "");
    sessionStorage.setItem("utm_referrer", "");
    sessionStorage.setItem("grfq_utm_captured", "1");
  } else if (!sessionStorage.getItem("grfq_utm_captured")) {
    // 無 UTM 且 session 尚未記錄 → 從 referrer 推算
    sessionStorage.setItem("utm_source", "");
    sessionStorage.setItem("utm_medium", "");
    try {
      sessionStorage.setItem("utm_referrer", document.referrer ? new URL(document.referrer).hostname : "(direct)");
    } catch (_) {
      sessionStorage.setItem("utm_referrer", document.referrer || "(direct)");
    }
    sessionStorage.setItem("grfq_utm_captured", "1");
  }
  // 無 UTM 且已記錄 → 不動
}

function getUTMParams() {
  return {
    utm_source:   sessionStorage.getItem("utm_source")   || "",
    utm_medium:   sessionStorage.getItem("utm_medium")   || "",
    utm_referrer: sessionStorage.getItem("utm_referrer") || "",
    quote_ref:    sessionStorage.getItem("quote_ref")    || "",
  };
}

// [feat] 2024.09.05 Greta -  Update quote list when the page is loaded from cache
window.addEventListener('pageshow', function(event) {
    // page loaded from cache
    if (event.persisted) {
      const storedQuoteList = JSON.parse(localStorage.getItem("quoteList")) || [];
      quoteList = storedQuoteList;
      quoteCounter = storedQuoteList?.length || 0;
      loadQuoteList();
      setCounter(quoteCounter);
      // console.log("update quoteList and counter")
    }
});